function sticky_init() {
    let target = jQuery('.single-venue .cover nav, .single-kcma .cover nav, .page-template-template-careers-landing .introduction nav, .page-template-template-careers-role-detail nav.tabs');

    if (target.length > 0) {
        let target_position_original_y = target.offset().top,
            stick_class = 'stick';

        jQuery(window).on('scroll', function () {
            let scroll_current = jQuery(window).scrollTop();
            if (!target.hasClass(stick_class) && scroll_current > target_position_original_y) {
                target.addClass(stick_class);
                jQuery('body').attr('data-nav-stuck', 1);
            } else if (target.hasClass(stick_class) && scroll_current < target_position_original_y) {
                target.removeClass(stick_class);
                jQuery('body').attr('data-nav-stuck', 0);
            }
        });
    }
        
}

function detect_in_viewport() {
    let targets = jQuery('.page-template-template-careers-role-detail .role'),
        tabs = jQuery('.page-template-template-careers-role-detail nav.tabs');

    if (targets.length > 0) {
        targets.each( function() {
            let target = jQuery(this);
            let target_position_original_y = target.offset().top,
                target_name = target.attr('id'),
                stick_class = 'stick';

            jQuery(window).on('scroll', function () {
                let scroll_current = jQuery(window).scrollTop() + 400;
                if (scroll_current > target_position_original_y) {
                    tabs.find('a').attr('data-active', 0);
                    tabs.find('a[href="#' + target_name + '"]').attr('data-active', 1);
                }
            });
        });
        
    }
}

jQuery(document).ready(function () {
    sticky_init();
    detect_in_viewport();
});